"use client";
import * as React from "react";
const SvgChangeSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m.05 13.6V12H8a4 4 0 0 1-2.83-1.18 4 4 0 0 1-.51-5.03l.88.88a2.77 2.77 0 0 0 2.5 4.11v-1.7l2.26 2.26zm3.29-3.4-.88-.87a2.8 2.8 0 0 0-.48-3.3A2.8 2.8 0 0 0 8 5.2h-.05v1.72L5.7 4.66 7.95 2.4v1.62a4 4 0 0 1 2.88 1.16 4 4 0 0 1 .5 5.03" }));
export {
  SvgChangeSharp as default
};
